export type AnalyticsEventName =
  | 'virtual_pageview'
  | 'popup'
  | 'cta_click'
  | 'input_field_focus'
  | 'custom_error'
  | 'request_outcome';
